import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import FAQSection from './components/FAQSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <CommentsSection />
        <FAQSection />
        <CardsSection />
        <AboutSection />
        <UpdatesSection />
        <IndexSection />
        <CarouselSection />
        <AppSection />
        <RankingSection />
        <FeaturesSection />
        <MediaSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}